import Button from "@mui/material/Button";
import React from "react";
import KftRegFlow from "../kftRegFlow/KftRegFlow";
import KftRegFlowVersionB from "../kftRegFlowVersionB/kftRegFlow";
import { getOrPickVariant } from "../utils/abVariant";
import { canAccessFlowVersionB } from "../utils/flowVersionBAccess";

export default function KftRegFlowABEntry() {
  // Real 5%-of-visitors A/B roll (sticky cookie) — kftRegFlowVersionB is now live for real traffic.
  const variant = React.useMemo(() => getOrPickVariant("kftregflow"), []);

  const [useVersionB, setUseVersionB] = React.useState(false);
  const canSwitchToVersionB = canAccessFlowVersionB();
  const shouldShowVersionB = variant === "B" || useVersionB;

  return (
    <>
      {canSwitchToVersionB && !shouldShowVersionB && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => setUseVersionB(true)}
          sx={{ mb: 2 }}
        >
          Open KftRegFlow B
        </Button>
      )}
      {shouldShowVersionB ? <KftRegFlowVersionB /> : <KftRegFlow />}
    </>
  );
}
